/**
 * Balance_Service API client (task 21.2).
 *
 * | Method / Path                                | Function                | Req.       |
 * | -------------------------------------------- | ----------------------- | ---------- |
 * | `GET /accounts`                              | {@link listAccounts}    | R4.2, R4.3 |
 * | `GET /accounts/{id}`                         | {@link getAccount}      | R2.1       |
 * | `GET /accounts/{id}/transactions?cursor=`    | {@link getTransactions} | R2.2, R2.3 |
 */

import { apiGet } from './client.js';
import type { Account, TransactionPage } from './types.js';

/** List all accounts owned by the signed-in customer (R4.2; empty ok, R4.3). */
export function listAccounts(): Promise<{ accounts: Account[] }> {
  return apiGet<{ accounts: Account[] }>('/accounts');
}

/** Fetch a single account's balance + currency (R2.1). */
export function getAccount(accountId: string): Promise<Account> {
  return apiGet<Account>(`/accounts/${encodeURIComponent(accountId)}`);
}

/**
 * Fetch a page of an account's transactions, newest first (R2.2). Pass the
 * `nextCursor` from a prior page to page forward (R2.3); omit for the first
 * page (latest ≤50).
 */
export function getTransactions(
  accountId: string,
  cursor?: string,
): Promise<TransactionPage> {
  return apiGet<TransactionPage>(
    `/accounts/${encodeURIComponent(accountId)}/transactions`,
    { query: { cursor } },
  );
}
